/* eslint-disable max-len */
import { getCache } from 'core/cache';

import forEach from 'lodash/forEach';

export default ({
  data, source, destination, treeTopName, isTreeTopEnabled,
}) => {
  const orderedContentList = {
    rootId: 'root',
    items: {
      root: {
        id: 'root',
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        data: { title: 'root' },
        children: [],
      },
    },
  };

  const createOrderedItem = ({ item, isTopLevelContent }) => {
    if (isTopLevelContent) orderedContentList.items.root.children.push(item.id);

    const { data: treeItemSelectorModalExpandedIds } = getCache('treeItemSelectorModalExpandedIds');
    const isExpanded = treeItemSelectorModalExpandedIds.includes(item.id);

    const children = item.content || [];
    const hasChildren = !!(children).length;

    const parentId = item.parent_id || 'root';

    const isSource = item.id === source?.id;
    const isDestination = item.id === destination?.id;

    const orderedItem = {
      id: item.id,
      isChildrenLoading: false,
      hasChildren,
      isExpanded,
      children: isSource ? [] : children.map((child) => createOrderedItem({ item: child, isTopLevelContent: false })),
      parentId,
      data: {
        ...item,
        title: item.name,
        isSource,
        isDestination,
      },
    };

    orderedContentList.items[item.id] = orderedItem;

    return orderedItem.id;
  };

  if (treeTopName) {
    const item = { id: 0, name: treeTopName, content: data, has_editor_permission: isTreeTopEnabled };
    createOrderedItem({ item, isTopLevelContent: true });
  } else {
    forEach(data, (item) => createOrderedItem({ item, isTopLevelContent: true }));
  }

  return orderedContentList;
};
